import { atom } from 'jotai';

import type { FeatureFlag } from '@/types/FeatureFlag';

/** The configuration request failed: what is on is neither known nor knowable for now. */
export const FEATURE_FLAGS_UNAVAILABLE = 'unavailable';

export type FeatureFlagsState = FeatureFlag[] | typeof FEATURE_FLAGS_UNAVAILABLE | null;

/**
 * The flags the backend serves, `null` while its configuration has not answered, and
 * `FEATURE_FLAGS_UNAVAILABLE` once that request has failed.
 *
 * Three states, not two. An empty list means "the backend told us, and nothing is on"; `null` means
 * "we have not been told yet"; unavailable means "we asked and could not find out". A gate that
 * reads `null` as "off" flashes its disabled state on every first load, and one that reads a
 * failure as an empty list turns an outage into a product decision -- it tells the reader the
 * feature is not enabled for their organization, and they never try again. See `FeatureGate`.
 */
export const featureFlagsAtom = atom<FeatureFlagsState>(null);
